import type { PlayerData } from '../PlayersStats.types';

import PlayerInfo from './PlayerInfo';
import PlayerStatText from './PlayerStat/PlayerStatText';

interface PlayerStatInjuredRowProps {
  playerData: PlayerData;
}

export default function PlayerStatInjuredRow({ playerData }: PlayerStatInjuredRowProps) {
  return (
    <div className="col-span-5 grid grid-cols-subgrid min-h-[40px]">
      <PlayerInfo
        name={playerData.name}
        position={playerData.position}
        jerseySrc={playerData.jerseySrc}
        flagSrc={playerData.flagSrc}
      />
      <PlayerStatText
        className="col-start-[stat-1]"
        text={playerData.injury || ''}
        icon={playerData.injuryIcon}
      />
    </div>
  );
}
